import React from "react";
import JuniorWorkspace from "./JuniorWorkspace";
import ScratchWorkspace from "./ScratchWorkspace";
import PythonWorkspace from "./PythonWorkspace";

const getEnvironmentForGrade = (gradeStr) => {
  if (!gradeStr) return "scratch";
  const numMatch = gradeStr.toString().match(/\d+/);
  const gradeNum = numMatch ? parseInt(numMatch[0], 10) : 5;
  if (gradeNum >= 1 && gradeNum <= 3) return "scratch_jr";
  if (gradeNum >= 4 && gradeNum <= 8) return "scratch";
  if (gradeNum >= 9) return "python";
  return "scratch";
};

const ModularWorkspace = ({
  environment = null, // "python" | "scratch" | "scratch_jr"
  mode = "free_play",  // "free_play" | "daily_practice" | "competition"
  initialData = null,
  selectedChild = null,
  readOnly = false,
  challengeData = null,
  showScratchTopBar = false, // Configurable flag to show/hide default Scratch menu bar
  showBackpack = false, // Configurable flag to show/hide default Scratch backpack panel
  onCodeChange = null,
  onGradeSubmit = null,
  onRequestLanguageChange = null,
  onSaveSnippet = null,
  onSaveSprite = null,
}) => {
  // Automatically resolve environment from student grade if not explicitly passed
  const activeEnvironment =
    environment || (selectedChild?.grade ? getEnvironmentForGrade(selectedChild.grade) : "scratch");

  const isJunior =
    activeEnvironment === "scratch_jr" ||
    activeEnvironment === "junior" ||
    activeEnvironment === "junior_blocks_basic" ||
    activeEnvironment === "junior_blocks_adv";

  const resolvedJuniorSubMode =
    activeEnvironment === "junior_blocks_basic"
      ? "basic"
      : activeEnvironment === "junior_blocks_adv"
      ? "advanced"
      : selectedChild?.juniorSubMode ||
        (selectedChild?.grade === "Class 1" ? "basic" : "advanced");

  const isPythonOrJs =
    activeEnvironment === "python" || activeEnvironment === "javascript";

  return (
    <div className="w-full h-full relative overflow-hidden bg-slate-900 flex flex-col min-h-[640px]">
      {isJunior && (
        <JuniorWorkspace
          mode={mode}
          subMode={resolvedJuniorSubMode}
          initialData={initialData}
          selectedChild={selectedChild}
          readOnly={readOnly}
          onCodeChange={onCodeChange}
          onGradeSubmit={onGradeSubmit}
          onSaveSprite={onSaveSprite}
        />
      )}

      {activeEnvironment === "scratch" && (
        <ScratchWorkspace
          mode={mode}
          initialData={initialData}
          selectedChild={selectedChild}
          readOnly={readOnly}
          showScratchTopBar={showScratchTopBar}
          showBackpack={showBackpack}
          onCodeChange={onCodeChange}
          onGradeSubmit={onGradeSubmit}
          onSaveSnippet={onSaveSnippet}
          onSaveSprite={onSaveSprite}
        />
      )}

      {isPythonOrJs && (
        <PythonWorkspace
          key="code_studio"
          mode={mode}
          initialCode={initialData}
          initialLanguage={activeEnvironment === "javascript" ? "javascript" : "python"}
          selectedChild={selectedChild}
          readOnly={readOnly}
          challengeData={challengeData}
          onCodeChange={onCodeChange}
          onGradeSubmit={onGradeSubmit}
          onRequestLanguageChange={onRequestLanguageChange}
          onSaveSnippet={onSaveSnippet}
        />
      )}
    </div>
  );
};

export default ModularWorkspace;
